import {action, observable} from "mobx";
import {IFilterable} from "./FormStore";

export type Fetcher = (params: {}) => Promise<IPaginator>;

export interface IPaginatorMeta {
    current_page: number;
    from: number;
    last_page: number;
    path: string;
    per_page: number;
    to: number;
    total: number;
}

export interface IPaginator {
    data: any[];
    links: any;
    // meta: IPaginatorMeta;
    current_page: number;
    from: number;
    last_page: number;
    path: string;
    per_page: number;
    to: number;
    total: number;
}

export class ListTableStore implements IFilterable {
    @observable isLoading = false;
    @observable page = 1;
    @observable items: any[] = [];
    @observable pagination: IPaginatorMeta;
    @observable orderColumn: string;
    @observable orderDirection: string = 'asc';

    private filters: any = null;
    private search: string|null = null;
    key = "id";
    @observable selectedKeys: any[] = [];

    protected readonly fetcher: Fetcher;

    constructor(fetcher: Fetcher, page: number, filters: any = null) {
        this.fetcher = fetcher;
        this.page = page;
        this.filters = filters;
    }

    @action
    load() {
        this.fetchItems(this.page);
    }

    @action
    setOrder(column: string, direction: string) {
        this.orderColumn =  column;
        this.orderDirection = direction;
    }

    @action
    fetchItems(page = 1) {
        this.page = page;
        this.isLoading = true;
        const sortData = (this.orderColumn) ? {orderColumn: this.orderColumn, orderDirection: this.orderDirection} : {};
        return this.fetcher({
            page: this.page,
            search: this.search,
            filters: this.filters,
            ...sortData
        }).then(this.setPaginator);
    }

    @action
    refresh() {
        this.deselectAllItems();
        return this.fetchItems(this.page);
    }

    @action
    setFilters(filters: any) {
        this.filters = filters;
        this.fetchItems(1);
    }

    @action
    setSearch(search: string) {
        this.search = search;
        this.fetchItems(1);
    }

    @action
    setPaginator = (paginator: IPaginator) => {
        this.isLoading = false;
        this.pagination = {
            current_page: paginator.current_page,
            from: paginator.from,
            last_page: paginator.last_page,
            path: paginator.path,
            per_page: paginator.per_page,
            to: paginator.to,
            total: paginator.total,
        };
        this.items = paginator.data;
    };

    @action
    selectItem(item: any) {
        this.selectedKeys.push(item[this.key]);
    }

    @action
    deselectItem(item: any) {
        this.selectedKeys = this.selectedKeys.filter((id: any) => id !== item[this.key]);
    }

    @action
    selectAllItems() {
        this.selectedKeys = this.items.map(item => item[this.key]);
    }

    @action
    deselectAllItems() {
        this.selectedKeys = [];
    }
}



// WEBPACK FOOTER //
// ./resources/js/stores/ListTableStore.ts